'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _AuthenticationManager = require('../authentication/AuthenticationManager');

var _AuthenticationManager2 = _interopRequireDefault(_AuthenticationManager);

var _MaskManagerContainer = require('../mask/MaskManagerContainer');

var _MaskManagerContainer2 = _interopRequireDefault(_MaskManagerContainer);

var _DialogManagerContainer = require('../dialog/DialogManagerContainer');

var _DialogManagerContainer2 = _interopRequireDefault(_DialogManagerContainer);

var _LocalizationService = require('../../services/LocalizationService');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModuleManager = function (_React$Component) {
  (0, _inherits3.default)(ModuleManager, _React$Component);

  function ModuleManager() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ModuleManager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ModuleManager.__proto__ || (0, _getPrototypeOf2.default)(ModuleManager)).call.apply(_ref, [this].concat(args))), _this), _this.module = function () {
      return _react2.default.createElement(
        _react.Fragment,
        null,
        _this.props.children,
        _react2.default.createElement(
          _MaskManagerContainer2.default,
          null,
          _react2.default.createElement(_DialogManagerContainer2.default, { getDialog: _this.props.getDialog })
        )
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ModuleManager, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.onWillMount();
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.isReady) {
        return this.props.loadingComponent || null;
      }

      return _react2.default.createElement(
        _reactIntl.IntlProvider,
        { defaultLocale: this.props.reactIntlDefaultLocale, locale: this.props.locale, messages: (0, _LocalizationService.getMessages)() },
        this.props.includeManageAuth ? _react2.default.createElement(
          _AuthenticationManager2.default,
          {
            manageAuthSite: this.props.manageAuthSite,
            site: this.props.site,
            isAuthenticated: this.props.isAuthenticated,
            isStandalone: this.props.isStandalone,
            onAuthenticationSuccess: this.props.onAuthenticationSuccess },
          this.module()
        ) : this.module()
      );
    }
  }]);
  return ModuleManager;
}(_react2.default.Component);

ModuleManager.propTypes = {
  isReady: _propTypes2.default.bool.isRequired,
  isStandalone: _propTypes2.default.bool.isRequired,
  isAuthenticated: _propTypes2.default.bool.isRequired,
  reactIntlDefaultLocale: _propTypes2.default.string.isRequired,
  locale: _propTypes2.default.string.isRequired,
  onWillMount: _propTypes2.default.func.isRequired,
  onAuthenticationSuccess: _propTypes2.default.func.isRequired,
  getDialog: _propTypes2.default.func.isRequired,
  children: _propTypes2.default.element,
  includeManageAuth: _propTypes2.default.bool,
  manageAuthSite: _propTypes2.default.func,
  site: _propTypes2.default.string
};

exports.default = ModuleManager;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/module/ModuleManager.js
// module id = 332
// module chunks = 10